/** @jsxImportSource @emotion/react */
import React from "react";

const GlobalLoader: React.FC = () => null;

export default GlobalLoader;